import { useParams } from 'react-router-dom';

import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import { useVocabulary, Vocabulary } from '@sayyesschool/frontend/features/vocabularies';
import { getWordEnding } from '@sayyesschool/frontend/utils/format';

import styles from './VocabularyPage.module.scss';

export default function VocabularyPage() {
    const params = useParams();

    const [vocabulary] = useVocabulary(params.id);

    if (!vocabulary) return <LoadingIndicator fullscreen />;

    const { title, numberOfLexemes } = vocabulary;
    const description = `${numberOfLexemes} ${getWordEnding('слов', numberOfLexemes, ['о', 'а', ''])}`;

    return (
        <Page
            className={styles.root}
            layout="narrow"
        >
            <Page.Header
                className={styles.header}
                title={title}
                description={description}
            />

            <Page.Content className={styles.content}>
                <Page.Section
                    variant="outlined"
                    compact
                >
                    <Vocabulary vocabulary={vocabulary} />
                </Page.Section>
            </Page.Content>
        </Page>
    );
}